import { useCallback, useEffect } from 'react';
import { useAdsContext } from '../contexts/AdsContext';
const useLoadAdSense = () => {
    const { adsEnabled, adSenseReady, adsSearchModel, adSense } = useAdsContext();
    const loadAdSense = useCallback(() => {
        const searchSaleOrRent = adsSearchModel?.distributionType ?? 'buy & rent';
        const searchEstateType = adsSearchModel?.estateType ?? '';
        const searchLocations = adsSearchModel?.locations?.[0] ?? '';
        const query = `${searchSaleOrRent} ${searchEstateType} ${searchLocations}`.trim();
        const pageOptions = {
            pubId: adSense?.pubId ?? '',
            query,
            styleId: adSense?.styleId ?? '',
            adsafe: 'high',
            resultsPageBaseUrl: window?.location?.href,
            resultsPageQueryParam: query,
        };
        const containers = ['afscontainer1', 'afscontainer2', 'afscontainer3', 'afscontainer4', 'afscontainer5'].map((container) => ({ container, number: 1 }));
        window._googCsa('ads', pageOptions, ...containers);
    }, [adsSearchModel]);
    useEffect(() => {
        if (!adSenseReady || !adsEnabled)
            return;
        loadAdSense();
    }, [adSenseReady, adsEnabled]);
};
export default useLoadAdSense;
